import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//
import { getSignedInUser } from '../../services/authService';
import Nav from './nav';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

// No app bar above this any more, so the page starts at a normal gutter
// rather than below 116px of blurred, near-empty chrome.
const Main = styled('div', {
  shouldForwardProp: (prop) => prop !== 'navCollapsed',
})(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(0),
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    transition: theme.transitions.create('margin-left', { duration: theme.transitions.duration.shorter }),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [navCollapsed, setNavCollapsed] = useState(false);

  // Safely get user from localStorage (may be null if not logged in or invalid)
  let authedUser = null;
  try {
    authedUser = getSignedInUser();
  } catch {
    // localStorage might have invalid JSON, treat as not authenticated
    authedUser = null;
  }

  if (!authedUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <StyledRoot>
      {authedUser ? (
        <Nav account={authedUser} collapsed={navCollapsed} onToggleNav={() => setNavCollapsed((prev) => !prev)} />
      ) : null}
      <Main navCollapsed={navCollapsed}>
        <Outlet />
      </Main>
      {/* Scoped container for global sensor-connection notices (e.g. the
          heartbeat's "Sensor disconnected"). The containerId keeps these
          routed here and prevents double-rendering with page-level default
          ToastContainers. */}
      <ToastContainer containerId="sensor-connection" position="bottom-right" />
    </StyledRoot>
  );
}
